module.exports = __webpack_public_path__ + "static/media/cuttlefish.f5b916ae.svg";